export enum ConnectedToMineStatusEnum {
    NotStarted = 'NotStarted',
    EmailSent = 'EmailSent',
    ConnectedToMine = 'ConnectedToMine',
    ConnectingToMine = 'ConnectingToMine'
}